import { jsx as _jsx } from "react/jsx-runtime";
import { ReactComponent as AIFillSparklesSvg } from 'assets/svgs/ai-fill-sparkles.svg';
const AIFillSparkles = (size)=>// eslint-disable-next-line react/display-name
    ({ className, color })=>/*#__PURE__*/ _jsx(AIFillSparklesSvg, {
            className: className,
            width: size,
            height: size,
            color: color
        });
export const AIFillSparkles16 = AIFillSparkles(16);
export const AIFillSparkles20 = AIFillSparkles(20);
export const AIFillSparkles24 = AIFillSparkles(24);
export const AIFillSparkles32 = AIFillSparkles(32);
